module.exports = __webpack_public_path__ + "static/media/checkedImage.a684e1e1.svg";